module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Light.4dfa927.eot";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-Light.eot
// module id = 8Mhk
// module chunks = 3